import React                   from 'react';
import PropTypes               from 'prop-types';
import Translations            from '../../../utils/Translations';
import {getFullScreenElement } from '../../../utils/Fullscreen';
import Flux                    from '../../../flux/Flux';
import Constants from '../../../flux/Constants';
import { Tooltip } from 'react-tooltip';

const body = document.querySelector('html');

class AlbumDescriptionLikeButton extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			checked:         this.props.checked,
            showAnimation:   false,
            showInitTooltip: this.props.showLikeBeforeBuy,
		};

		this.onClick            = this.onClick.bind(this);
		this.onFullscreenChange = this.onFullscreenChange.bind(this);
		this.setShowAnimation   = this.setShowAnimation.bind(this);
	}

    componentDidMount() {
        document.addEventListener('webkitfullscreenchange', this.onFullscreenChange, false);
		document.addEventListener('mozfullscreenchange', this.onFullscreenChange, false);
		document.addEventListener('fullscreenchange', this.onFullscreenChange, false);
		document.addEventListener('MSFullscreenChange', this.onFullscreenChange, false);
        Flux.Gallery.addVideoPauseListener(this.setShowAnimation);
        body && body.addEventListener('mouseleave', this.setShowAnimation);
        setTimeout(() => {
            this.setState({showInitTooltip: false});
        }, 4000);
    }

	componentDidUpdate(prevProps) {
		if (prevProps.checked !== this.props.checked) {
			this.setState({checked: this.props.checked});
		}
	}

    componentWillUnmount() {
        document.removeEventListener('webkitfullscreenchange', this.onFullscreenChange, false);
		document.removeEventListener('mozfullscreenchange', this.onFullscreenChange, false);
		document.removeEventListener('fullscreenchange', this.onFullscreenChange, false);
		document.removeEventListener('MSFullscreenChange', this.onFullscreenChange, false);
        Flux.Gallery.removeVideoPauseListener(this.setShowAnimation);
        body && body.removeEventListener('mouseleave', this.setShowAnimation);
    }

    onFullscreenChange() {
        if (!getFullScreenElement()) {
            setTimeout(() => {
            this.setShowAnimation();
            }, 500);
        }
    }

    setShowAnimation() {
        this.setState({showAnimation: true});
        setTimeout(() => {
            this.setState({showAnimation: false});
        }, 1000);
    }

	onClick(e) {
        if (this.props.showLikeBeforeBuy && !this.props.isVotingVisible) {
            this.setState({showInitTooltip: true}, () => {
                setTimeout(() => {
                    this.setState({showInitTooltip: false});
                }, 4000);
            });
        } else {
            const checked = !this.state.checked;
            if (this.props.onClick) {
                this.props.onClick(e, checked);
            }
        }
	}

	render() {
		const { baseClassName, text, isBought } = this.props;
        const tooltipId = this.props.tooltipPosition === Constants.Tooltip.place.Top ? 'tooltip' : 'tooltip-' + this.props.tooltipPosition;
        const tooltipText = isBought ? Translations.get('LikeTooltip') :  Translations.get('tooltip.video-like-before-buy');
		return (
			<div className={baseClassName + '-el ' + (this.state.showAnimation && !this.props.checked && this.props.isBought ? baseClassName + '-el--animation ' : '') + (this.props.showLikeBeforeBuy && !this.props.isVotingVisible ? baseClassName + '-el--disabled' : '')} onClick={this.onClick} data-tooltip-content={tooltipText} data-tooltip-id={tooltipId}>
				<i className={'icon ' + (this.state.checked ? "-icon-like-full" : "-icon-like-line")}></i>
				{this.props.isVotingVisible && (text !== null && text !== undefined) && <span className="value">{text}</span>}
                {this.state.showInitTooltip && <Tooltip openOnClick={true} defaultIsOpen={true} id="tooltip-bottom-start" place="bottom-start" className="custom-react-tooltip" />}
			</div>
		);
	}
}

AlbumDescriptionLikeButton.propTypes = {
	baseClassName: PropTypes.string,
	text:          PropTypes.oneOfType([
						PropTypes.number,
						PropTypes.string
					]),
	onClick:       PropTypes.func,
	checked:       PropTypes.bool,
    tooltipPosition: PropTypes.string,
    showLikeBeforeBuy: PropTypes.bool,
    isVotingVisible:    PropTypes.bool,
    isBought:           PropTypes.bool,
};

AlbumDescriptionLikeButton.defaultProps = {
	baseClassName: '',
	checked:       false,
    tooltipPosition: Constants.Tooltip.place.Top,
    showLikeBeforeBuy: false,
    isVotingVisible:    false,
    isBought:           false,
};

export default AlbumDescriptionLikeButton;
